import type { ReactElement } from 'react';
import { clsx } from 'cn';

/** @internal Connection status component */
export const ConnectionStatus = ({
  connected,
  className
}: {
  connected: boolean;
  className?: string;
}): ReactElement => {
  return (
    // Device connection status indicator
    <span
      className={clsx('i-mdi-circle', className, {
        'text-error': !connected,
        'text-success': connected
      })}
    />
  );
};
